import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AnchorList.css';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, hideContainerByChild, getDictionaryItem, getColorByTheme, getPageThemeColors } from '../../utils';
import { ReactComponent as ArrowIcon } from '../../resources/icons/IconChevronBottomRight.svg';
import SelectReplace from '../atoms/SelectReplace';
var compareLinksArrays = function compareLinksArrays(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  var compareAccum = 0;
  arr1.forEach(function (link) {
    if (arr2.find(function (item) {
      return item.id === link.id;
    })) {
      compareAccum++;
    }
  });
  return compareAccum === arr1.length;
};
var AnchorList = function AnchorList(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var dictionary = get(fields, 'data.dictionary');
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    links = _useState2[0],
    setLinks = _useState2[1];
  var linksRef = useRef([]);
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isVdsite = _useState4[0],
    setIsVdsite = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectValue = _useState6[0],
    setSelectValue = _useState6[1];
  var mobileDefaultOption = getDictionaryItem(dictionary, 'mobileDefaultOption');
  var title = get(fields, 'data.datasource.title.jss.value');
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var ColorHex = get(params, 'ColorHex');
  var variables = BackgroundColorHex ? {
    "--m03-anchor-nav-primary-color": BackgroundColorHex,
    "--m03-anchor-nav-active-primary-color": ActiveColorHex,
    "--m03-anchor-nav-color": ColorHex
  } : {
    "--m03-anchor-nav-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m03-anchor-nav-active-primary-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m03-anchor-nav-color": getColorByTheme(primaryPageThemeColor)
  };
  var selectPrimaryColor = BackgroundColorHex || (primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary);
  var options = useMemo(function () {
    return links.map(function (link, index) {
      return {
        value: link.id,
        label: link.dataset.title,
        index: index,
        link: link
      };
    });
  }, [links]);
  useEffect(function () {
    var checkLinks = function checkLinks() {
      var domLinks = [].slice.call(document.querySelectorAll('[data-id="anchor-item"]'));
      if (!compareLinksArrays(domLinks, linksRef.current)) {
        linksRef.current = domLinks;
        setLinks(domLinks);
      }

      // @ts-ignore
      hideParentContainer(domLinks);
    };
    var interval = setInterval(checkLinks, 1000);
    setTimeout(checkLinks, 100);
    setTimeout(checkLinks, 500);
    return function () {
      clearInterval(interval);
    };
  }, []);
  var changeEvent = function changeEvent(value) {
    setSelectValue(value);
    scrollToItem(value.link, value.index);
  };
  var scrollToItem = function scrollToItem(link, index) {
    var _scroll = function scroll(links, callback) {
      if (canUseDOM && links.length) {
        var header = document.querySelector('.main-navigation-block');
        if (header) {
          header = header.closest('.module-group');
        }
        if (header) {
          header = header.parentNode;
        }
        document.documentElement.scrollTop = links[0].nextSibling.offsetTop - (header ? header.offsetHeight : 0);
        if (links.length > 1) {
          setTimeout(function () {
            return _scroll(links.slice(1), callback);
          }, 100);
        } else {
          callback();
        }
      }
    };
    if (canUseDOM) {
      link.click();
      setTimeout(function () {
        var scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        _scroll(links.slice(0, index + 1), function () {
          document.documentElement.style.scrollBehavior = scrollBehavior;
        });
      }, 100);
    }
  };
  var hideParentContainer = function hideParentContainer(domLinks) {
    var arr = _toConsumableArray(domLinks);
    if (domLinks.length > 0) {
      //if all the links don't have title, parent container will be hidden
      arr = arr.map(function (item) {
        return item.dataset.title ? true : false;
      }).filter(function (item) {
        return item !== false;
      });
      if (arr.length === 0) {
        hideContainerByChild('.anchor-list', '.container');
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "anchor-list",
    style: variables
  }, /*#__PURE__*/React.createElement("h3", {
    className: "anchor-list__title"
  }, title), links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "anchor-list__item d-none d-md-block",
      key: link.id
    }, /*#__PURE__*/React.createElement("span", {
      onClick: function onClick() {
        return scrollToItem(link, index);
      },
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, /*#__PURE__*/React.createElement(ArrowIcon, {
      className: "icon"
    }), link.dataset.title));
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none"
  }, /*#__PURE__*/React.createElement(SelectReplace, {
    name: "jump-to-section-selector",
    id: "jump-to-section-selector",
    label: title,
    options: options,
    placeholder: mobileDefaultOption,
    changeEvent: changeEvent,
    componentColor: selectPrimaryColor,
    value: selectValue
  }))));
};
var commonStyles = "c1v8hkws";
var ltrStyles = "lhg1wvg";
var rtlStyles = "r1tv99qc";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default AnchorList;